import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useDispatch } from 'react-redux';
import { apiClient } from '../../../utils/axios';
import { useState } from 'react';
import { AxiosError } from 'axios';

const keysToRemove = ['tax_amount', 'charge_amount', 'discount_amount'];

export const createProducts = async (payload) => {
  const { data } = await apiClient.post('/products', payload);
  return data;
};

export const useCreateProductHandler = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const [error, setError] = useState(null);

  const mutation = useMutation({
    mutationFn: createProducts,
    onSuccess: () => {
      dispatch(showSnackbar({ message: 'Product created successfully.' }));
      queryClient.invalidateQueries({ queryKey: ['products'] });
    },
    onError: (error) => {
      if (error instanceof AxiosError) {
        if (error.response.status === 400) {
          setError(error.response.data.errors);
          return;
        }
        dispatch(showSnackbar({ message: error.response.data, severity: 'error' }));
      }
      dispatch(showSnackbar({ message: error, severity: 'error' }));
    },
  });

  const onSubmit = async (data) => {
    const cleanedData = Object.fromEntries(Object.entries(data).filter(([key]) => !keysToRemove.includes(key)));
    mutation.mutate(cleanedData);
  };

  return {
    data: mutation.data,
    isError: mutation.isError,
    error: error,
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
    onSubmit: onSubmit,
  };
};
